export class OwnerRegistrationRawDto {
  ownerIdentifier: string;
  firstName: string;
  lastName: string;
  contactId: number;
  middleName: string;
  contactTypeId: number;
  isCompanyOwner: boolean;
  get fullName() {
    return (
      (!!this.firstName ? this.firstName + ' ' : '') +
      (!!this.middleName ? this.middleName + ' ' : '') +
      this.lastName
    );
  }
}
